const Colors = {
  PRIMARY: "#8cc4fc",
  PRIMARY_DARK: "#406ab9",
  WHITE: "#fff",
  RED: "#FF5733",
};
export default Colors;
